<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div class="orderlistBox" v-for="item in dataList" :key="item.RowNumber">
        <div class="flexbox">
          <span class="order-no flexmiddle">
            订单编号：
            <em class="grey">{{item.TransactionOrderlID}}</em>
          </span>
          <span class="status" v-if="item.LX_TransactionStatus == 1">已完成</span>
          <span class="status success" v-else>{{getPayState(item.LX_TransactionStatus)}}</span>
        </div>
        <div class="flexbox bd">
          <img class="pic" :src="item.CoverPhoto" alt />
          <div class="flexmiddle">
            <div class="usergrade textcut">
              <em class="label">会员级别：</em>
              {{item.DistributionLeveName}}
            </div>
            <div class="date">{{item.AddDatetime}}</div>
            <p v-if="item.LX_TransactionStatus==0" class="btnBox">
              <span class="qxBtn btn" @click="cancelOrder(item.TransactionOrderlID)">取消订单</span>
              <span class="fkBtn btn" @click="payOrder(item.TransactionOrderlID)" >马上付款</span>
            </p>
          </div>
          <div class="fr">
            <em class="price">{{item.PayableCoinCount}}</em>元
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { Dialog, Toast } from "vant";
import common from "../tools/common";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  props: {
    PayStatus: 0
  },
  mounted() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetTransactionDistributionLevel",
        pageIndex: 1,
        PayStatus: ""
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      var _payStatus = that.PayStatus == undefined ? "" : that.PayStatus;
      //    console.log(_payStatus);
      Object.assign(this.options, {
        PayStatus: _payStatus
      });
      console.log(this.options);
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.TransactionDistributionLevelList==null||res.TransactionDistributionLevelList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.TransactionDistributionLevelList.length > 0) {
              res.TransactionDistributionLevelList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.TransactionDistributionLevelList;
          }
        },
        error => {}
      );
    },
    getPayState(status) {
      var _text = common.getPayState(status);
      return _text;
    },
    cancelOrder(orderId) {
      var that = this;
      Dialog.confirm({
        title: "系统提示",
        message: "确定取消此订单！"
      })
        .then(() => {
          that.$store
            .dispatch({
              type: "CancelTransactionOrderVue",
              OrderId: orderId
            })
            .then(
              res => {
                Toast(res.Message);
                if (res.IsSuccess) {
                  var _filterData = that.dataList.filter(
                    x => x.TransactionOrderlID == orderId
                  );
                  //console.log(_filterData);
                  _filterData[0].LX_TransactionStatus = 3;
                }
              },
              error => {}
            );
        })
        .catch(() => {});
    },
    payOrder(orderId) {
      var that=this;
      var _openId = sessionStorage.getItem("OpenId");
      var _options={
          type:"WeiXinPay",
          orderId:orderId,
          openid: _openId       
      };
      //console.log(_options);
      that.$store.dispatch(_options).then(
        res => {
          //console.log(res);
          that.$weixin.weiXinPay(res,function(){
              //that.onRefresh();
              var _filterData = that.dataList.filter(
                x => x.TransactionOrderlID == orderId
              );
              _filterData[0].LX_TransactionStatus = 1;//更新为已支付状态
              that.getMember();
          },function(){

          });
        },
        error => {}
      );

    },
    getMember(){
      var _options= {
        type: "GetMemberIndex"
      };
      this.$store.dispatch(_options);

    },
  },
  created() {}
};
</script>

<style scoped>
/**订单列表**/
.flexmiddle {
  flex: 1;
  overflow: hidden;
}
.orderlistBox {
  border-bottom: 1px solid #eee;
  padding: 15px;
  background: #fff;
}
.orderlistBox .order-no {
  color: #999;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.orderlistBox .order-no .grey {
  color: #555;
}
.orderlistBox .status {
  font-size: 15px;
  margin-left: 20px;
  color: #777;
}
.orderlistBox .status.success {
  color: #f60;
}
.orderlistBox > .bd {
  margin-top: 10px;
}
.orderlistBox > .bd > .pic {
  width: 90px;
  height: 64px;
  background: #545454;
  object-fit: cover;
}
.orderlistBox > .bd > .flexmiddle {
  margin: 0 8px;
}
.orderlistBox > .bd > .flexmiddle .usergrade {
  font-size: 14px;
}
.orderlistBox > .bd > .flexmiddle .usergrade .label {
  color: #777;
}
.orderlistBox > .bd > .flexmiddle .date {
  color: #999;
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
}
.orderlistBox > .bd > .flexmiddle .btnBox {
  color: #ccc;
  margin-top: 6px;
}
.orderlistBox > .bd > .flexmiddle .btnBox .btn {
  display: inline-block;
  margin-right: 2%;
  border: 1px solid #ccc;
  border-radius: 999px;
  padding: 0px 5%;
  font-size: 12px;
  margin-bottom: 4px;
}
.orderlistBox > .bd > .flexmiddle .btnBox .btn:last-child {
  margin-right: 0;
}
.orderlistBox > .bd > .flexmiddle .btnBox .btn.qxBtn {
  background-color: #e9e9e9;
  color: #555;
  border-color: #555;
}
.orderlistBox > .bd > .flexmiddle .btnBox .btn.fkBtn {
  background-color: #ffd7c1;
  color: #f60;
  border-color: #f60;
}
.orderlistBox > .bd > .fr {
  font-size: 14px;
  margin-left: 10px;
}
.orderlistBox > .bd > .fr .price {
  color: #f60;
  font-size: 21px;
  margin-right: 4px;
}
</style>